var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#006DF0;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#006DF0;}\n\t.st6{fill:#37CE93;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.1,81.18v2.77h-7.8v-2.78c-7.79,0.41-13.62,2.05-13.62,4.02c0,2.27,7.8,4.12,17.41,4.12 c9.62,0,17.41-1.84,17.41-4.12C67.5,83.24,61.77,81.61,54.1,81.18z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 17.69,
    cy: 81.06,
    rx: 10.41,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 82.31,
    cy: 81.06,
    rx: 10.41,
    ry: 3.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.99,38.25 40,38.25 41.72,12.8 58.27,12.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.29,
    y1: 46.04,
    x2: 46.29,
    y2: 83.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 53.7,
    y1: 46.04,
    x2: 53.7,
    y2: 83.95
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.06,23.64c0,0,2.84-0.97,4.21-3.08v11.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.84,56.09h15.75v5.98H8.24L5.79,28.65c0,0,9.62-0.52,7.52,20.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 17.69,
    y1: 62.07,
    x2: 17.69,
    y2: 80.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13.37,
    y1: 80.38,
    x2: 22.35,
    y2: 80.38
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.16,56.09H70.42v5.98h21.35l2.45-33.42c0,0-9.62-0.52-7.52,20.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 82.31,
    y1: 62.07,
    x2: 82.31,
    y2: 80.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 86.52,
    y1: 80.38,
    x2: 77.76,
    y2: 80.38
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.8,46.04H21.19c-1.42,0-2.56-1.15-2.56-2.56v0c0-1.42,1.15-2.56,2.56-2.56H78.8c1.42,0,2.56,1.15,2.56,2.56 v0C81.37,44.89,80.22,46.04,78.8,46.04z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.45,
    y1: 83.95,
    x2: 58.92,
    y2: 83.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 45.54,
    y1: 10.7,
    x2: 45.54,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 50,
    y1: 10.7,
    x2: 50,
    y2: 14.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 54.46,
    y1: 10.7,
    x2: 54.46,
    y2: 14.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.ede6367a80b57107e59933ac7971b1a9.svg";
export { ForwardRef as ReactComponent };